<template>
    <div
        :id="id"
        class="message-item"
        :class="{
            [`message-item--${host}`]: true,
            [`message-item--${name}`]: true
        }" @mouseover="toggle(1)" @mouseout="toggle(0)">
        <div class="message-item__row"
            :class="{ 'text-has-evaluation' : isSupportEvaluation }"
            :style="{
                'padding-bottom': paddingBottom
            }">
            <!-- S 客服头像 -->
            <div class="message-item__host"
                v-if="isService">
                <div class="message-item__avatar"
                    :class="{
                        'no-avatar': !layout.isShowHost
                    }">
                    <img
                        v-if="layout.isShowHost"
                        :src="serviceAvatar" />
                </div>
            </div>
            <!-- E 客服头像 -->

            <!-- S 用户头像 -->
            <div class="message-item__host"
                v-if="isUser">
                <div class="message-item__status">
                    <icon
                        v-if="status === STATUS.SENDING"
                        name="loading"
                        title="发送中"
                        :width="14"
                        :height="14"
                        class="rotate" />
                    <icon
                        v-else-if="status === STATUS.SUCCESS"
                        name="send_succ"
                        title="发送成功"
                        :style="{'--color': color}"
                        :width="14"
                        :height="14" />
                    <icon
                        v-else-if="status === STATUS.FAIL"
                        name="send_fail"
                        title="发送失败"
                        :width="14"
                        :height="14" />
                </div>
            </div>
            <!-- E 用户头像 -->

            <!-- S 除头像外区域 -->
            <div class="message-item__stage">
                <!-- S 自适应宽度，用于子元素定位 -->
                <div class="message-item__main">
                    <div class="message-item__content"
                        ref="messageItemContent"
                        @click="showTime"
                        v-longPress="{
                            methods: longPress
                        }">
                        <slot></slot>
                    </div>
                    <!-- 以下消息类型无 id：录音中、等待回复 -->
                    <template v-if="id">
                        <!-- PC消息操作 -->
                        <div class="message-item__trigger"
                            v-if="isDesktop && isSupportActions">
                            <span v-show="!isHover&&isUser&&chatTarget==='human'&&isFrom" :class="[!isUnread ? 'font-blue' : 'font-grey']">{{!isUnread ? '未读' : '已读'}}</span>
                            <span v-show="isHover" class="message-item__trigger-icon icon_dot" @click="showAction"></span>
                        </div>
                        <div class="message-item__trigger" v-else>
                            <span v-show="!isHover&&isUser&&chatTarget==='human'&&isFrom" :class="[!isUnread ? 'font-blue' : 'font-grey']">{{!isUnread ? '未读' : '已读'}}</span>
                        </div>
                        <!-- 消息时间 -->
                        <p v-if="isShowTime"
                            class="message-item__time"
                            :style="{
                                'top': timeStyleTop
                            }">{{time}}</p>
                        <!-- 消息操作 -->
                        <message-action
                            v-if="isSupportActions && isShowAction"
                            :isShow.sync="isShowAction"
                            :name="name"
                            :messageId="id"
                            :actions="supportActions"
                            :placement="actionPlacement"
                            :copyContent="copyContent"
                            :retryContent="retryContent"></message-action>
                        <!-- 评价操作 -->
                        <message-evaluation
                            v-if="isSupportEvaluation"
                            :value="evaluationValue"
                            :messageId="id"
                            :idFromServer="server.id"></message-evaluation>
                    </template>
                </div>
                <!-- E 自适应宽度，用于子元素定位 -->
            </div>
            <!-- E 除头像外区域 -->
        </div>
    </div>
</template>

<script>
    import Icon from '@/components/Icon'
    import get from 'lodash.get'
    import MessageAction from '../MessageAction'
    import MessageEvaluation from '../MessageEvaluation'
    import { STATUS, HOST } from '@/constants/message'
    import { EVALUATION_VALUE, MESSAGE_NAME, MESSAGE_FROM } from '@/constants/message'
    // import { getTextWidth } from '@/utils'
    import { getAppOffsetTop } from '@/utils/dom'
    import ROBOT_AVATAR_DEFAULT from '@/assets/img/robot.svg'
    import HUMAN_AVATAR_DEFAULT from '@/assets/img/human.svg'

    const ACTION_ORDER = ['copy', 'withdrew', 'retry']

    const ACTION_CONFIG_FOR_MESSAGE_TYPE = {
        'copy': [MESSAGE_NAME.TEXT],
        'retry': [MESSAGE_NAME.TEXT, MESSAGE_NAME.IMAGE]
    }

    const ACTION_POPOVER_HEIGHT = 67
    const THE_HEADER_HEIGHT = 55

    function detectPlacement (event) {
        const target = event.target
        const { top } = target.getBoundingClientRect()
        if ((top - getAppOffsetTop()) < (ACTION_POPOVER_HEIGHT + THE_HEADER_HEIGHT)) {
            return 'bottom'
        } else {
            return 'top'
        }
    }

    const PADDING_BOTTOM = {
        NONE: '0px', // time 和 evaluation 均不显示
        TIME: '17px', // 仅显示 time
        EVALUATION: '30px', // 仅显示 evaluation
        STACK: '47px' // 同时显示time 和 evaluation
    }

    // function getTimeAndEvaluationWidth (time, evaluationValue) {
    //     const evaluationWidth = evaluationValue === EVALUATION_VALUE.NONE
    //         ? 70
    //         : 35
    //     const timeWidth = getTextWidth(time, 12)
    //     const gap = 10
    //     return evaluationWidth + timeWidth + gap
    // }

    export default {
        name: 'MessageItem',
        components: {
            Icon,
            MessageAction,
            MessageEvaluation
        },
        props: {
            name: {
                type: String,
                required: true
            },
            baseProps: {
                type: Object,
                required: true
            },
            layout: {
                type: Object,
                required: true
            },
            robot: {
                type: Object,
                required: false
            },
            server: {
                type: Object,
                required: false
            },
            copyContent: {
                type: String,
                required: false
            },
            retryContent: {
                type: String,
                required: false
            },
            chatTarget: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                STATUS,
                isShowTime: false,
                isLongPress: false,
                isShowAction: false,
                actionPlacement: 'top',
                paddingBottom: 0,
                isHover: false,
            }
        },
        computed: {
            id () {
                return this.baseProps['id']
            },
            // 消息主体：客服 or 用户
            host () {
                return this.baseProps['host']
            },
            // 消息状态：针对用户
            status () {
                return this.baseProps['status']
            },
            time () {
                return this.baseProps['time']
            },
            isUnread () {
                return this.baseProps['isUnread']
            },
            // 客服
            isService () {
                return this.host === HOST.SERVICE
            },
            // 用户
            isUser () {
                return this.host === HOST.USER
            },
            // 判断来自谁发的
            isFrom () {
                if (this.retryContent === '人工' || this.retryContent === '转机器人') {
                    return false
                }
                if (this.server) {
                    if (this.server.hasOwnProperty('from')) {
                        if (this.server.hasOwnProperty('fromId')) {
                            if (this.server.fromId != '0') {
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            // 该消息是否支持评价
            isSupportEvaluation () {
                return this.host === HOST.SERVICE
                    && this.name === MESSAGE_NAME.TEXT
                    && this.robot
                    && 'evaluationValue' in this.robot
                    && this.server
                    && this.server.id
                    && this.$store.getters.robotEnable
            },
            evaluationValue () {
                if (this.isSupportEvaluation) {
                    return this.robot.evaluationValue
                }
                return EVALUATION_VALUE.NONE
            },
            // 该消息类型支持的动作
            supportActions () {
                const result = []

                ACTION_ORDER.forEach(action => {
                    if (action === 'retry' && this.status !== STATUS.FAIL) {
                        return true
                    }
                    const ACTION_CONFIG_FOR_SPECIFIC_TYPE = ACTION_CONFIG_FOR_MESSAGE_TYPE[action]
                    if (Array.isArray(ACTION_CONFIG_FOR_SPECIFIC_TYPE) &&
                        ACTION_CONFIG_FOR_SPECIFIC_TYPE.includes(this.name)) {
                        result.push(action)
                    }
                })

                return result
            },
            isSupportActions () {
                return this.supportActions.length > 0
            },
            timeStyleTop () {
                if (this.paddingBottom === PADDING_BOTTOM.STACK) {
                    return 'calc(100% + 35px)'
                } else {
                    return 'calc(100% + 5px)'
                }
            },
            isDesktop () {
                return this.$eventBus.isDesktop
            },
            serviceAvatar () {
                if (this.isUser) {
                    return ''
                }
                const messageFrom  = this.server.from
                const messageFromId = this.server.fromId
                if (this.$eventBus.company.globalDisplay) {
                    return get(this.$eventBus.humanUsers, `${messageFromId}.avatar`)
                        || this.$eventBus.backupUserAvatar
                        || HUMAN_AVATAR_DEFAULT
                } else {
                    if (messageFrom === MESSAGE_FROM.USER) {
                        return get(this.$eventBus.humanUsers, `${messageFromId}.avatar`)
                            || this.$eventBus.backupUserAvatar
                            || HUMAN_AVATAR_DEFAULT
                    } else if (messageFrom === MESSAGE_FROM.ROBOT) {
                        return get(this.$eventBus.robot, 'img')
                            || ROBOT_AVATAR_DEFAULT
                    } else { // MESSAGE_FROM.SYSTEM
                        return ''
                    }
                }
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            }
        },
        methods: {
            longPress ({ $event: event }) {
                if (this.$eventBus.isDesktop) {
                    return
                }
                const target = event.target
                const classList = target.classList
                if (classList.contains('prevent-long-press')) {
                    return
                }
                this.isLongPress = true
                this.showAction(event)
            },
            showAction (event) {
                this.actionPlacement = detectPlacement(event)
                this.isShowAction = true
            },
            toggle (sign) {
                if (sign) {
                    this.isHover = true
                } else {
                    // setTimeout(() => {
                    //     // console.log(e.toElement, e.toElement.classList, e.screenX, e.screenY)
                    //     if (!e) {
                    //         this.isHover = false
                    //     }
                    //     if (e && Array.isArray(e.toElement.classList) && !e.toElement.classList.includes('action__list')) {
                    //         this.isHover = false
                    //     }
                    // }, 800)
                    this.isHover = false
                }
            },
            reset () {
                this.isHover = false
            },
            showTime () {
                if (this.name === MESSAGE_NAME.TEXT) {
                    this.isShowTime = !this.isShowTime
                    this.paddingBottom = this.getPaddingBottom()
                }
            },
            getPaddingBottom () {
                if (!this.isSupportEvaluation) {
                    return this.isShowTime ? PADDING_BOTTOM.TIME : PADDING_BOTTOM.NONE
                }

                if (this.isShowTime) {
                    const $messageItemContent = this.$refs.messageItemContent
                    if (!$messageItemContent) {
                        return PADDING_BOTTOM.NONE
                    }

                    // if ($messageItemContent.offsetWidth < getTimeAndEvaluationWidth(this.time, this.evaluationValue)) {
                    return PADDING_BOTTOM.STACK
                    // } else {
                    //     return PADDING_BOTTOM.EVALUATION
                    // }
                } else {
                    return PADDING_BOTTOM.EVALUATION
                }
            }
        },
        created () {
            // 默认不显示 time，该方法无需使用 $refs，故放在 created
            this.paddingBottom = this.getPaddingBottom()
        }
    }
</script>

<style lang="scss" scoped>
    @import "./css/index.scss";
    .message-item__status {
        .icon {
            border-radius: 50%;
            background-color: var(--color);
        }
    }
</style>
